(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kb-shipping-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kb-shipping-countdown')) {
    class KbShippingCountdown extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.kb-countdown__text');
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const d = this.dataset;
        const now = new Date();
        const cutoff = new Date();
        cutoff.setHours(parseInt(d.cutoff, 10) || 17, 0, 0, 0);
        let nextDay = false;
        if (now >= cutoff) {
          cutoff.setDate(cutoff.getDate() + 1);
          nextDay = true;
        }
        const diff = Math.max(0, cutoff.getTime() - now.getTime());
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        const day = nextDay ? d.dayAfter : d.tomorrow;
        const time = `${h}${d.unitH} ${pad(m)}${d.unitM} ${pad(s)}${d.unitS}`;
        this.text.innerHTML = '';
        this.text.append(`${d.prefix} `);
        const strong = document.createElement('span');
        strong.className = 'kb-countdown__time';
        strong.textContent = time;
        this.text.append(strong, `, ${d.suffix.replace('[dag]', day)}`);
      }
    }

    customElements.define('kb-shipping-countdown', KbShippingCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
